import React, { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

function readOnline(): boolean {
  return typeof navigator === "undefined" ? true : navigator.onLine;
}

/**
 * Hors ligne après chargement : message minimal (pas de cache métier / API).
 */
export default function OfflineGate({
  children,
}: {
  children: React.ReactNode;
}): React.JSX.Element {
  const [online, setOnline] = useState(readOnline);

  useEffect(() => {
    const onOnline = () => setOnline(true);
    const onOffline = () => setOnline(false);
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, []);

  if (online) {
    return <>{children}</>;
  }

  return (
    <div
      role="alert"
      className="fixed inset-0 z-[200] flex flex-col items-center justify-center gap-3 bg-slate-950 p-6 text-center text-slate-100"
    >
      <WifiOff
        className="h-12 w-12 text-emerald-500/90"
        strokeWidth={1.5}
        aria-hidden
      />
      <p className="max-w-md text-lg font-semibold">
        Vous êtes hors ligne. Reconnectez-vous pour continuer.
      </p>
    </div>
  );
}
